import { selectEvidenceResolver, updateEvidence } from "../redux/EvidenceSlice";
import { useAppDispatch, useAppSelector } from "../redux/Hooks";

export default function GenderEvidenceIndicator() {
    const dispatch = useAppDispatch();
    const evidenceResolver = useAppSelector(selectEvidenceResolver);
    const femaleStatus = evidenceResolver.resolveEvidence('Female');
    const maleStatus = evidenceResolver.resolveEvidence('Male');

    const toggle = (gender: 'Male' | 'Female') => () => {
        const status = gender === 'Female' ? femaleStatus : maleStatus;
        const other = gender === 'Female' ? 'Male' : 'Female';
        
        if (status === true) {
            dispatch(updateEvidence({ type: gender, status: false }));
        } else {
            dispatch(updateEvidence({ type: gender, status: true }));
        }
        dispatch(updateEvidence({ type: other, status: undefined }));
    };

    const clear = () => {
        dispatch(updateEvidence({ type: 'Male', status: undefined }));
        dispatch(updateEvidence({ type: 'Female', status: undefined }));
    };

    return (
        <div className="d-flex justify-content-start align-items-center gap-3">
            <div>Gender</div>
            <div className="btn-group" role="group">
                <button type="button" onClick={toggle('Female')} className={genderClassName(femaleStatus)}><i className="bi-gender-female"></i></button>
                <button type="button" onClick={toggle('Male')} className={genderClassName(maleStatus)}><i className="bi-gender-male"></i></button>
                <button type="button" onClick={clear} className="btn btn-outline-primary"><i className="bi-x"></i></button>
            </div>
        </div>
    );
}

function genderClassName(status: true | false | undefined): string {
    if (status === true) {
        return "active btn btn-outline-success";
    } else if (status === false) {
        return "active btn btn-outline-danger";
    } else {
        return "btn btn-outline-primary";
    }
}